import apiBaseUrl from '../../utils/config.js';

class AuthorizationService {
  constructor() {
    this.baseUrl = `${apiBaseUrl}/patient-authorization`;
  }

  getToken() {
    return localStorage.getItem("jwt");
  }

  getAuthHeaders() {
    const token = this.getToken();
    return {
      'Content-Type': 'application/json',
      ...(token && { Authorization: `Bearer ${token}` }),
    };
  }

  async #request(endpoint, method, body = null) {
    const url = `${this.baseUrl}${endpoint}`;
    const options = {
      method,
      headers: this.getAuthHeaders(),
    };

    if (body) {
      options.body = JSON.stringify(body);
    }

    try {
      const response = await fetch(url, options);
      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Request failed: ${errorText}`);
      }
      return response.json();
    } catch (error) {
      console.error(`Error in API request: ${error}`);
      throw error;
    }
  }

  async addPatientAuthorization(data) {
    return this.#request(`/patientAuthorization/add`, 'POST', data);
  }

  async editAuthorization(authId, updatedAuthorization) {
    return this.#request(`/edit/${authId}`, 'PUT', updatedAuthorization);
  }

  async editSpecificColumn(authId, columnName, value) {
    const params = new URLSearchParams({ columnName, value });
    return this.#request(`/edit-column/${authId}?${params.toString()}`, 'PATCH');
  }

  async removeAuthorization(authId) {
    return this.#request(`/remove/${authId}`, 'DELETE');
  }

  async findByPatientId(patientId) {
    return this.#request(`/find-by-patient/${patientId}`, 'GET');
  }

  async findByAuthId(authId) {
    return this.#request(`/find-by-auth/${authId}`, 'GET');
  }

  async getLatestAuthId(patientId) {
    return this.#request(`/latest-auth/${patientId}`, 'GET');
  }

  async getInsptIdByAuthId(authId) {
    return this.#request(`/insptId/${authId}`, 'GET');
  }
}

export default AuthorizationService;
